var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "280px",
    height: "300px",
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79968 12.5927H4.79291C4.05826 12.5869 3.35128 12.8643 2.82751 13.3638C2.30372 13.8633 2.00606 14.5442 2 15.2565V25.3379C2.01359 26.8208 3.26377 28.0125 4.79291 28H9.79968C10.5343 28.006 11.2413 27.7286 11.7651 27.2291C12.2889 26.7296 12.5866 26.0487 12.5926 25.3362V15.2565C12.5866 14.5442 12.2889 13.8633 11.7651 13.3638C11.2413 12.8643 10.5343 12.5869 9.79968 12.5927Z",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79968 2.00102H4.79291C3.29452 1.96136 2.04518 3.08649 2 4.51624V6.2245C2.04518 7.65427 3.29452 8.7794 4.79291 8.73972H9.79968C11.298 8.7794 12.5474 7.65427 12.5926 6.2245V4.51624C12.5474 3.08649 11.298 1.96136 9.79968 2.00102Z",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2744 17.4073H23.2794C24.0143 17.4136 24.7217 17.1365 25.2459 16.6369C25.77 16.1372 26.068 15.4562 26.074 14.7436V4.66382C26.068 3.95146 25.7704 3.2706 25.2466 2.77105C24.7228 2.2715 24.0157 1.99417 23.2811 2.00009H18.2744C17.5398 1.99417 16.8327 2.2715 16.3089 2.77105C15.7851 3.2706 15.4874 3.95146 15.4814 4.66382V14.7436C15.4874 15.4559 15.7851 16.1367 16.3089 16.6363C16.8327 17.1358 17.5398 17.4131 18.2744 17.4073Z",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2744 27.999H23.2794C24.7784 28.0396 26.0288 26.9142 26.074 25.4837V23.7755C26.0288 22.3457 24.7794 21.2207 23.2811 21.2603H18.2744C16.776 21.2207 15.5266 22.3457 15.4814 23.7755V25.4821C15.5256 26.9125 16.7753 28.0385 18.2744 27.999Z",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.78068af37631328205597d7f7d8cd765.svg";
export { ForwardRef as ReactComponent };